export default __webpack_public_path__ + "static/media/gigatonball.18ed0235.png";